// extracted by mini-css-extract-plugin
export default {"user":"UserMenu_user__5j7hw"};